import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  DATA_CONNECTOR_GET_PERMISSION_FLAGS_BEGIN,
  DATA_CONNECTOR_GET_PERMISSION_FLAGS_SUCCESS,
  DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE,
  DATA_CONNECTOR_GET_PERMISSION_FLAGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function getPermissionFlags(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_PERMISSION_FLAGS_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: DATA_CONNECTOR_GET_PERMISSION_FLAGS_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE,
              data: { error: 'Failed' },
            });
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetPermissionFlagsError() {
  return {
    type: DATA_CONNECTOR_GET_PERMISSION_FLAGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_PERMISSION_FLAGS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPermissionFlagsPending: true,
        getPermissionFlagsError: null,
      };

    case DATA_CONNECTOR_GET_PERMISSION_FLAGS_SUCCESS:
      // The request is success
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: null,
        permissionFlags: action.data,
      };

    case DATA_CONNECTOR_GET_PERMISSION_FLAGS_FAILURE:
      // The request is failed
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: action.data.error,
      };

    case DATA_CONNECTOR_GET_PERMISSION_FLAGS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPermissionFlagsError: null,
      };

    default:
      return state;
  }
}
